import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { HkbkplacementsRoutingModule } from './hkbkplacements-routing.module';
import { HkbkplacementsListComponent } from './hkbkplacements-list/hkbkplacements-list.component';
import { HkbkplacementsCreateComponent } from './hkbkplacements-create/hkbkplacements-create.component';

@NgModule({
  declarations: [HkbkplacementsListComponent, HkbkplacementsCreateComponent],
  imports: [
    CommonModule,
    HkbkplacementsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class HkbkplacementsModule { }
